var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from 'react';
import styled from 'styled-components';
import { FormattedMessage, useIntl } from 'react-intl';
import { Controller, useForm } from 'react-hook-form';
import { PrimaryButton } from '../../../core/components/Button';
import AvatarUploader from '../../../social/components/CommunityForm/AvatarUploader';
// TODO: should not be importing styles from another component.
import { AboutTextarea, Counter, ErrorMessage, Field, Form, FormBlockBody, FormBlockContainer, FormBlockHeader, FormBody, Label, LabelCounterWrapper, TextField, } from '../../../social/components/CommunityForm/styles';
const MaxProfileLength = 500;
const ButtonContainer = styled.div `
  margin-top: 16px;
`;
const FormBlock = ({ title, children }) => (React.createElement(FormBlockContainer, null,
    React.createElement(FormBlockHeader, null, title),
    React.createElement(FormBlockBody, { edit: true }, children)));
const UserProfileForm = ({ user, onSubmit, className }) => {
    var _a, _b;
    const { formatMessage } = useIntl();
    const { register, handleSubmit, formState: { errors }, watch, control, } = useForm({
        defaultValues: {
            displayName: user.displayName,
            description: (_a = user.description) !== null && _a !== void 0 ? _a : '',
            avatarFileId: (_b = user.avatarFileId) !== null && _b !== void 0 ? _b : null,
        },
    });
    const description = watch('description');
    const displayName = watch('displayName');
    return (React.createElement(Form, { className: className, onSubmit: handleSubmit(onSubmit) },
        React.createElement(FormBody, null,
            React.createElement(FormBlock, { title: React.createElement(FormattedMessage, { id: "UserProfileForm.title" }) },
                React.createElement(Controller, { name: "avatarFileId", render: (_a) => {
                        var _b = _a.field, { ref } = _b, rest = __rest(_b, ["ref"]);
                        return (React.createElement(AvatarUploader, Object.assign({}, rest, { "data-qa-anchor": "user-profile-form-avatar-uploader" })));
                    }, control: control }),
                React.createElement(Field, { error: errors.name },
                    React.createElement(LabelCounterWrapper, null,
                        React.createElement(Label, { htmlFor: "displayName", className: "required" },
                            React.createElement(FormattedMessage, { id: "UserProfileForm.displayname" })),
                        React.createElement(Counter, null,
                            displayName.length,
                            "/100")),
                    React.createElement(TextField, Object.assign({}, register('displayName', {
                        required: formatMessage({ id: 'UserProfileForm.requiredDisplayName' }),
                    }), { "data-qa-anchor": "user-profile-form-display-name-input", placeholder: formatMessage({ id: 'UserProfileForm.namePlaceholder' }), maxLength: 100 })),
                    React.createElement(ErrorMessage, { errors: errors, name: "displayName" })),
                React.createElement(Field, { error: errors.description },
                    React.createElement(LabelCounterWrapper, null,
                        React.createElement(Label, { htmlFor: "description" },
                            React.createElement(FormattedMessage, { id: "UserProfileForm.about" })),
                        React.createElement(Counter, null,
                            description.length,
                            "/",
                            MaxProfileLength)),
                    React.createElement(AboutTextarea, Object.assign({}, register('description'), { "data-qa-anchor": "user-profile-form-description-textarea", placeholder: formatMessage({ id: 'UserProfileForm.requiredDescription' }), maxLength: MaxProfileLength })),
                    React.createElement(ErrorMessage, { errors: errors, name: "description" })),
                React.createElement(ButtonContainer, null,
                    React.createElement(PrimaryButton, { "data-qa-anchor": "user-profile-form-save-button", type: "submit" },
                        React.createElement(FormattedMessage, { id: "save" })))))));
};
export default memo(UserProfileForm);
//# sourceMappingURL=index.js.map